<template>
    <el-dialog title="港口系统配煤" :visible="visible" :show="show" width="50%" @close="close" :close-on-click-modal="false" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="港口名称" class="input" prop="portName">
                <el-select v-model="ruleForm.portName"  placeholder="港口名称">
                    <el-option v-for="item in portList" :value="item.portName" :label="item.portName" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="目标热值" class="input" prop="targetHots">
                <el-input v-model="ruleForm.targetHots" autocomplete="off" placeholder="目标热值"></el-input>
            </el-form-item>
            <el-form-item label="目标硫分" class="input" prop="targetLiufen">
                <el-input v-model="ruleForm.targetLiufen" autocomplete="off" placeholder="目标硫分"></el-input>
            </el-form-item>
            <el-form-item label="目标吨数" class="input" prop="totalCount">
                <el-input v-model="ruleForm.totalCount" autocomplete="off" placeholder="目标吨数"></el-input>
            </el-form-item>
            <el-form-item label="最大煤泥占比" class="input" prop="maxMnWeight">
                <el-input v-model.number="ruleForm.maxMnWeight" autocomplete="off" placeholder="最大煤泥占比"></el-input>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" @click="commit()">提交</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'cocalSystemMatchAdd',
        props:{
            show: {
                type: Boolean,
                default: false
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.getPortList();
                }
            },
        },
        data(){
            var validateNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error('请输入有效的数字或小数'));
                    }
                }, 100);
            };
            var validateTotalCount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && value%100==0) {
                        callback();
                    } else {
                        callback(new Error('请输入100的倍数'));
                    }
                }, 100);
            };
            return{
                url:base.get().url,
                visible:false,
                ruleForm:{
                    portName:'',
                    targetHots:'',
                    targetLiufen:'',
                    totalCount:'',
                },
                rules:{
                    portName:[{ required: true, message: '请输入港口名称', trigger: 'blur' }],
                    targetHots:[
                        { required: true, message: '请输入目标热值', trigger: 'blur' },
                        {validator:validateNumber,trigger:'blur'}
                    ],
                    targetLiufen:[
                        { required: true, message: '请输入硫分', trigger: 'blur' },
                        {validator:validateNumber,trigger:'blur'}
                    ],
                    totalCount:[
                        { required: true, message: '请输入目标吨数', trigger: 'blur' },
                        {validator:validateTotalCount,trigger:'blur'}
                    ],
                    maxMnWeight:[
                        { required: true, message: '请输入煤泥最大占比', trigger: 'blur' },
                    ],
                },
                portList:[],
            }
        },
        methods:{
            validateMultipleOf100(rule, value, callback) {
                if (!value) {
                    return callback(new Error('输入不能为空'));
                }
                if (value % 100 !== 0) {
                    callback(new Error('请输入100的倍数'));
                } else {
                    callback();
                }
            },
            close(){
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let loading = this.$loading({
                            lock:true,
                            text:'计算中，请稍候.....',
                            background:'rgba(0,0,0,0.5)'
                        });
                        this.ruleForm.matchType = '系统配煤';
                        this.$http({
                            url:  this.url+`portMatchResult/`+"save",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                loading.close();
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            getPortList(){
                this.$http({
                    url:  this.url+`port/`+"list",
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.portList = data.data;
                    } else {
                        this.$message.error(data.msg);
                    }
                })

            }

        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
    .detail-form-content .el-select {
        width: 100%;
    }
    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }
</style>